import React from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-white/60">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
